<template>
  <transition name="slide-fade" v-if="hide">
    <div class="single-look">
      <div class="look-nav">
        <div class="handle-wrapper" @click="backPath">
          <div class="icon-font">&#xe612;</div>
          返回
        </div>
        <div class="look-nav-center">{{statusValue.materialName}}</div>
        <div class="handle-wrapper" @click="handleData">
          <div class="icon-font">&#xec11;</div>
          变更
        </div>
      </div>
      <div class="single-look-content">
        <div class="single-look-content-wrapper">
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.72vw;z-index: 999">物料代码：</div>
              <div class="input-wrapper" style="padding: 0.63vw">
                <div class="popover" style="text-align: left" v-if="statusValue.materialCode.length < 18">
                  {{statusValue.materialCode}}
                </div>
                <div class="detail-item" style="width: 100%;display: block" v-if="statusValue.materialCode.length >= 18">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="statusValue.materialCode">
                    <div class="popover" slot="reference">{{statusValue.materialCode}}</div>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">烟叶简称：</div>
              <div class="input-wrapper">
                <input disabled="true" v-model="statusValue.materialName" placeholder=""/>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 2.67vw">批次号：</div>
              <div class="input-wrapper">
                <input v-model="statusValue.materialBatchNum" disabled="true" placeholder=""/>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.72vw;z-index: 999">仓库位置：</div>
              <div class="input-wrapper" style="padding: 0.63vw">
                <div class="popover" style="text-align: left" v-if="statusValue.siteName.length < 8">
                  {{statusValue.siteName}}
                </div>
                <div class="detail-item" style="width: 100%;display: block" v-if="statusValue.siteName.length >= 8">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="statusValue.siteName">
                    <div class="popover" slot="reference">{{statusValue.siteName}}</div>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
          <div class="single-look-content-list" style="z-index: 998">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw;">养护阶段：</div>
              <DropDown :content="getMaintainStageData(inputValue.maintainStage)" :items="maintainStageData" v-on:sendInfo = "showInfoMaintainStag"></DropDown>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">养护天数：</div>
              <div class="input-suffix-wrapper" style="margin-right: 0">
                <input v-model="inputValue.maintainDays" placeholder=""/>
                <div class="input-suffix">(天)</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">调养日期：</div>
              <div class="input-wrapper">
                <el-date-picker
                  v-model="inputValue.aftercareDateStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择调养日期">
                </el-date-picker>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 3.56vw">库龄：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.age" placeholder=""/>
                <div class="input-suffix">（天）</div>
              </div>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">养护数量：</div>
              <div class="input-suffix-wrapper" style="margin-right: 0">
                <input v-model="inputValue.maintainCount" placeholder=""/>
                <div class="input-suffix">(担)</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">降氧完成时间：</div>
              <div class="input-suffix-wrapper" style="margin-right: 0">
                <input v-model="inputValue.oxygenReductionDays" placeholder=""/>
                <div class="input-suffix">(天)</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">申请日期：</div>
              <div class="input-suffix-wrapper">
                <el-date-picker
                  :disabled="true"
                  v-model="statusValue.createdTime"
                  type="date"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </div>
            <div class="input-contain" style="z-index: 997">
              <div class="input-title" style="padding-left: 2.67vw">负责人：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.principalName" placeholder=""/>
              </div>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">申请编号：</div>
              <div class="input-wrapper">
                <input disabled="true" v-model="statusValue.applyNum" placeholder=""/>
              </div>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 1.78vw">到期提醒：</div>
              <div class="input-wrapper">
                <el-date-picker
                  v-model="inputValue.expireTime"
                  type="datetime"
                  placeholder="请选择到期提醒">
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title">包芯水分下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.wetCoreChipLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">包芯水分上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.wetCoreChipUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">包芯温度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.tempCoreChipUpper" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">包芯温度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.tempCoreChipLower" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.2vw">CO₂浓度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.concentrationCo2Upper" placeholder=""/>
                <div class="input-suffix">（PPM）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.15vw">CO₂浓度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.concentrationCo2Lower" placeholder=""/>
                <div class="input-suffix">（PPM）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">垛内温度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.stackTempUpper" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">垛内温度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.stackTempLower" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>

          </div>
          <div class="single-look-content-list">
            <div class="input-contain">
              <div class="input-title">垛内湿度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.stackMoistureUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title">垛内湿度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.stackMoistureLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.75vw">O₂浓度上限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.oxygenUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain">
              <div class="input-title" style="padding-left: 0.75vw">O₂浓度下限：</div>
              <div class="input-suffix-wrapper">
                <input disabled="true" v-model="statusValue.oxygenLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
          </div>
          <div class="text-area-wrapper">
            <div class="text-area-title" style="padding-left: 3.56vw">备注：</div>
            <textarea v-model="inputValue.remark" rows="1" class="text-area-input"></textarea>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import {queryAlarm, detailMaintainPlan, changeStage} from '../../../api/maintain'
import {daysDistance, renderTime} from '../../../tools/methods'
export default {
  name: 'Change',
  components: { DropDown },
  data () {
    return {
      hide: false,
      moduleType: '01',
      maintainStageData: [
        {name: '自然醇化阶段', value: '01'},
        {name: '防霉杀虫阶段', value: '02'},
        {name: '气调醇化阶段', value: '03'},
        {name: '气调保质阶段', value: '04'}
      ],
      statusValue: {
        createdTime: '',
        concentrationCo2Lower: '',
        concentrationCo2Upper: '',
        oxygenLower: '',
        oxygenUpper: '',
        stackMoistureLower: '',
        stackMoistureUpper: '',
        stackTempLower: '',
        stackTempUpper: '',
        tempCoreChipLower: '',
        tempCoreChipUpper: '',
        wetCoreChipLower: '',
        wetCoreChipUpper: '',
        age: '',
        approveStatus: '',
        applyNum: '',
        principalName: '',
        siteName: '',
        materialName: '',
        materialCode: '',
        materialBatchNum: '',
        warehouseBuildTime: ''
      },
      inputValue: {
        id: '',
        maintainStage: '',
        maintainDays: '',
        aftercareDateStart: '',
        oxygenReductionDays: '',
        maintainCount: '',
        remark: '',
        expireTime: ''
      }
    }
  },
  created () {
    let id = this.$route.query.id
    let _this = this
    setInterval(function () {
      _this.hide = true
    }, 100)
    detailMaintainPlan({id: id}).then(res => {
      console.log(res)
      this.inputValue.id = res.data.id
      this.inputValue.maintainStage = res.data.maintainStage
      this.inputValue.maintainDays = res.data.maintainDays
      this.inputValue.aftercareDateStart = res.data.aftercareDateStart
      this.inputValue.oxygenReductionDays = res.data.oxygenReductionDays
      this.inputValue.maintainCount = res.data.maintainCount
      this.inputValue.remark = res.data.remark
      this.inputValue.expireTime = res.data.expireTime

      this.statusValue.approverTime = res.data.maintainStageData.approverTime
      this.statusValue.concentrationCo2Lower = res.data.maintainStageData.concentrationCo2Lower
      this.statusValue.concentrationCo2Upper = res.data.maintainStageData.concentrationCo2Upper
      this.statusValue.oxygenLower = res.data.maintainStageData.oxygenLower
      this.statusValue.oxygenUpper = res.data.maintainStageData.oxygenUpper
      this.statusValue.stackMoistureUpper = res.data.maintainStageData.stackMoistureUpper
      this.statusValue.stackMoistureLower = res.data.maintainStageData.stackMoistureLower
      this.statusValue.stackTempLower = res.data.maintainStageData.stackTempLower
      this.statusValue.stackTempUpper = res.data.maintainStageData.stackTempUpper
      this.statusValue.tempCoreChipLower = res.data.maintainStageData.tempCoreChipLower
      this.statusValue.tempCoreChipUpper = res.data.maintainStageData.tempCoreChipUpper
      this.statusValue.wetCoreChipLower = res.data.maintainStageData.wetCoreChipLower
      this.statusValue.wetCoreChipUpper = res.data.maintainStageData.wetCoreChipUpper
      this.statusValue.age = daysDistance(res.data.warehouseBuildTime)
      this.statusValue.createdTime = renderTime(res.data.createdTime)
      this.statusValue.approveStatus = res.data.approveStatus
      this.statusValue.applyNum = res.data.applyNum
      this.statusValue.approverTime = res.data.approverTime
      this.statusValue.principalName = res.data.principalName
      this.statusValue.siteName = res.data.siteName
      this.statusValue.materialCode = res.data.materialCode
      this.statusValue.materialName = res.data.materialName
      this.statusValue.materialBatchNum = res.data.materialBatchNum
      this.statusValue.warehouseBuildTime = res.data.warehouseBuildTime
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    getMaintainStageData: function (maintainStage) {
      if (maintainStage === '01') {
        return '自然醇化阶段'
      } else if (maintainStage === '02') {
        return '防霉杀虫阶段'
      } else if (maintainStage === '03') {
        return '气调醇化阶段'
      } else {
        return '气调保质阶段'
      }
    },
    showInfoMaintainStag: function (data) {
      console.log(data)
      this.inputValue.maintainStage = data.value
      queryAlarm({phases: data.value}).then(res => {
        this.statusValue.concentrationCo2Lower = res.data.concentrationCo2Lower
        this.statusValue.concentrationCo2Upper = res.data.concentrationCo2Upper
        this.statusValue.oxygenLower = res.data.oxygenLower
        this.statusValue.oxygenUpper = res.data.oxygenUpper
        this.statusValue.stackMoistureLower = res.data.stackMoistureLower
        this.statusValue.stackMoistureUpper = res.data.stackMoistureUpper
        this.statusValue.stackTempLower = res.data.stackTempLower
        this.statusValue.stackTempUpper = res.data.stackTempUpper
        this.statusValue.tempCoreChipLower = res.data.tempCoreChipLower
        this.statusValue.tempCoreChipUpper = res.data.tempCoreChipUpper
        this.statusValue.wetCoreChipLower = res.data.wetCoreChipLower
        this.statusValue.wetCoreChipUpper = res.data.wetCoreChipUpper
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    },
    showInfo: function (data) {
      console.log(data)
      this.inputValue.principalId = data.id
      this.inputValue.principalName = data.name
    },
    backPath: function () {
      this.$router.go(-1)
    },
    handleData: function () {
      console.log(this.inputValue)
      changeStage(this.inputValue).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$message({
            message: res.data,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  @import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/conserve/Change.vue